import React from 'react';
import PropTypes from 'prop-types';
import { FaReceipt, FaPlus } from 'react-icons/fa';
import { Button } from 'components/common';

const StarterOther = ({ setShowModalOther }) => (
  <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-py-12 tw-px-6">
    <span
      className="tw-flex tw-items-center tw-justify-center tw-w-16 tw-h-16 tw-rounded-2xl tw-mb-4 tw-text-white"
      style={{ backgroundImage: 'linear-gradient(135deg, #f59e0b, #d97706)', boxShadow: '0 8px 20px rgba(217,119,6,0.30)' }}
    >
      <FaReceipt size={24} />
    </span>
    <h3 className="tw-text-slate-800 tw-font-semibold tw-text-lg tw-mb-1">Other Booking</h3>
    <p className="tw-text-slate-500 tw-mb-4 tw-max-w-md">Create a booking for other purposes, such as a visa, for the trip.</p>
    <Button size="sm" variant="primary" leftIcon={FaPlus} onClick={() => setShowModalOther(true)}>Create record now</Button>
  </div>
);

StarterOther.propTypes = {
  setShowModalOther: PropTypes.func.isRequired,
};

export default StarterOther;
